export default __webpack_public_path__ + "static/media/playstore.82b48319.png";